import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import api from '../services/api';

const useAuthStore = create(
  persist(
    (set, get) => ({
      user:            null,
      token:           null,
      isAuthenticated: false,
      loading:         false,
      activeBranch:    null, // { _id, name, code, isMain }

      login: async (email, password) => {
        set({ loading: true });
        try {
          const res = await api.post('/auth/login', { email, password });
          const { token, user } = res.data;
          // Auto-select first branch (main branch if exists)
          const branches = user.branches || [];
          const defaultBranch = branches.find(b => b.isMain) || branches[0] || null;
          set({
            user,
            token,
            isAuthenticated: true,
            loading: false,
            activeBranch: defaultBranch,
          });
          return res.data;
        } catch (err) {
          set({ loading: false });
          throw err;
        }
      },

      logout: async () => {
        try { await api.post('/auth/logout'); } catch {}
        set({ user: null, token: null, isAuthenticated: false, activeBranch: null });
      },

      switchBranch: (branch) => {
        set({ activeBranch: branch });
      },

      updateUser: (data) => {
        set(s => ({ user: { ...s.user, ...data } }));
      },

      // Returns the active branch _id as string
      getActiveBranchId: () => {
        const s = get();
        return s.activeBranch?._id?.toString() ||
               s.user?.branches?.[0]?._id?.toString() ||
               null;
      },

      // Returns all available branches for this user
      getBranches: () => {
        return get().user?.branches || [];
      },
    }),
    {
      name: 'auth-v2',
      partialize: (s) => ({ user: s.user, token: s.token, activeBranch: s.activeBranch }),
    }
  )
);

export default useAuthStore;
